export default {
    methods: {
      getRoomAbilityWithCorrectIcon(roomAbility = {}) {
        return {
          ...roomAbility,
          iconName: roomAbility.iconName || 0,
          allowed: roomAbility.allowed === undefined ? false : roomAbility.allowed,
          allowedHeaderContent: (roomAbility.allowedHeaderContent === undefined || typeof roomAbility.allowedHeaderContent === 'undefined')
            ? true
            : roomAbility.allowedHeaderContent
        };
      },
      checkRoomAbilityTitles(roomAbility = {}) {
        return !!roomAbility.titles && Object.values(roomAbility.titles).every(Boolean);
      },
      fixEmptyRoomAbilityTitles(titles = []) {
        return titles.filter(Boolean);
      }
    },
};